"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _UserCard = _interopRequireDefault(require("./components/UserCard"));
var _GeneralInfo = _interopRequireDefault(require("./components/GeneralInfo"));
var _Address = _interopRequireDefault(require("./components/Address"));
var _Education = _interopRequireDefault(require("./components/Education"));
var _Coin = _interopRequireDefault(require("./components/Coin"));
var _Badge = _interopRequireDefault(require("./components/Badge"));
var _SkillSet = _interopRequireDefault(require("./components/SkillSet"));
var _user = require("@/api/user");
var _coin = require("@/api/coin");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _organizations = require("@/api/organizations");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _index = _interopRequireDefault(require("@/directive/permission/index.js"));
var _lifehikesInitData = require("@/lifehikes-init-data");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
// 权限判断指令
var _default = exports.default = {
  name: "UserEdit",
  directives: {
    permission: _index.default
  },
  components: {
    UserCard: _UserCard.default,
    GeneralInfo: _GeneralInfo.default,
    Address: _Address.default,
    Education: _Education.default,
    Coin: _Coin.default,
    Badge: _Badge.default,
    SkillSet: _SkillSet.default
  },
  data: function data() {
    return {
      loading: false,
      user: {},
      coin: {},
      activeTab: "general",
      organizationList: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["name", "avatar", "roles", "introduction", "email"])),
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var token, uuid;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            token = (0, _cookie.getCookie)("ACCESS_TOKEN");
            uuid = typeof _this.$route.params.id === "undefined" ? _this.user.uuid : _this.$route.params.id;
            _context.n = 1;
            return _this.getList().catch(function (e) {});
          case 1:
            _context.n = 2;
            return _this.getUser(token, uuid).catch(function (e) {});
          case 2:
            // 保留原有错误处理

            // 根据权限动态添加请求
            if ((0, _permission.default)(["root", "otr-digital-producer"])) {
              _this.getUserCoin(token, uuid, false).catch(function (e) {});
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    getUser: function getUser(token, uuid) {
      var _this2 = this;
      this.loading = true;
      return (0, _user.getUser)(token, uuid).then(function (response) {
        _this2.loading = false;
        // console.log('page-useredit-response', response.data)
        _this2.user = response.data;
        var userRole = _this2.user.role;
        var newUserRoses = _lifehikesInitData.newRoleList.filter(function (p) {
          return userRole.includes(p.key);
        }).map(function (item) {
          return item.val;
        });
        _this2.$set(_this2.user, "role", newUserRoses);
      }).catch(function (err) {
        _this2.loading = false;
        (0, _log.showDebugLog)("page-user-err", err);
        (0, _log.displayPopupMessage)(err, "error");
      });
    },
    getUserCoin: function getUserCoin(token, uuid) {
      var _this3 = this;
      return (0, _coin.getUserCoin)(token, uuid, false).then(function (response) {
        // console.log('page-useredit-coin-response', response.data)
        _this3.coin = response.data;
        // console.log('coin', this.coin)
      }).catch(function (err) {
        (0, _log.showDebugLog)("page-user-err", err);
        (0, _log.displayPopupMessage)(err, "error");
      });
    },
    getList: function getList() {
      var _this4 = this;
      this.loading = true;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      return (0, _organizations.getAllOrganizations)(token).then(function (response) {
        _this4.loading = false;
        _this4.organizationList = response.data.rows;
      }).catch(function (error) {
        _this4.loading = false;
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    }
  }
};